import { getStore } from '@wellesley/store'
import { api } from '@wellesley/openapi'

export enum PrivacyOptions {
  public = 'Public',
  private = 'Private',
  secret = 'Secret group',
}

export enum JoinModeOptions {
  anyone = 'Anyone can join',
  request = 'Request to join',
  invite = 'Invite only',
}

export enum VisibilityOptions {
  visible = 'Visible',
  unlisted = 'Unlisted',
}

export const checkGroupSlug = async (groupname?: string) => {
  if (!groupname)
    return {
      exists: false,
      message: '',
    }

  try {
    const { taken, reserved } = await getStore()
      .dispatch(
        api.endpoints.getApiV1NamesCheck.initiate(
          {
            name: groupname,
            nameScope: 'GROUP',
          },
          { forceRefetch: true },
        ),
      )
      .unwrap()

    return {
      exists: taken || reserved,
      message: taken
        ? 'Slug already in use. Try another one'
        : reserved
          ? 'Reserved words detected. Please try alternatives'
          : '',
    }
  } catch {
    return {
      exists: false,
      message: '',
    }
  }
}
